export const optionEndpoint = 'option';

export interface Options {
  localCodesPromo: boolean;
  friendsPromoSalesforce: boolean;
  promoSuccessMessage: string;
  localCodesPromoSuccessMessage: string;
  friendsPromoSalesforceSuccessMessage: string;
}

export const defaultOptions: Options = {
  localCodesPromo: false,
  friendsPromoSalesforce: false,
  promoSuccessMessage: '',
  localCodesPromoSuccessMessage: '',
  friendsPromoSalesforceSuccessMessage: '',
};



// WEBPACK FOOTER //
// ./src/app/models/options.ts